module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter104"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Canadian born Jimmy Greening came to England in the late 1930s and subsequently enlisted for service as a pilot in the Fleet Air Arm during the latter stages of the war, flying Barracudas with 822 Squadron from Thorney Island in Hampshire.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("“My interest in aviation stemmed from early days in Prince Albert, Saskatchewan. My cousin George was a bush pilot and Prince Albert, being at the end of the railway line, was the base for aircraft serving the northern half of Saskatchewan, including Fairchild 71s, Norsemen, Wacos, etc. My interest continued when I arrived in England in 1938 to work for de Havilland at Stag Lane and I managed to get the occasional flight with the Civil Air Guard. I joined the navy on 28 December 1942.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Sub Lieutenant Jim Langford also trained to fly Barracudas, but converted to the Avenger to fly operationally with 820 Squadron aboard HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indefatigable")]), _vm._v(" including bombing operations against the Japanese mainland in 1945.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("“I was called up in February ’42, but didn’t actually join the navy until the following December, which seemed an awful long time to have to wait before going down to the south of England to two naval establishments to learn all about how to do a bend and a hitch and to learn all about naval history. So then came the ground school, square bashing, how to fire a rifle, and do guard duty on the camp at night.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter4"
  }, [_c('span', {
    staticClass: "character-style6"
  }, [_vm._v("LUFTWAFFE")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("In Germany, recruits entering the Luftwaffe, including officer cadets, were similarly sent to a recruit depot, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flieger Ausbildungs Regiment")]), _vm._v(", which was roughly equivalent to the RAF’s ITW system. They would spend between six and twelve months here, almost exclusively devoted to military and physical training, with limited instruction in map reading and wireless principles. As the war progressed, this period was progressively reduced down to about two months.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText2"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Recruits then moved on to a pool called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fluganwaerterkompanie")]), _vm._v(", where they spent another two months studying aeronautical subjects before commencing training at an elementary flying school. However, by 1942 the system was beginning to break down under the pressure of ever-mounting losses as the tide of war turned against Germany.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText2"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Leutnant Norbert Hannig flew the Bf 109 and Fw 190 with Jagdgeschwader 54 ‘Grünherz’ (Green Hearts) on the Eastern Front, scoring forty-two victories. He then flew the Me 262 with Jagdverband 44 and Jagdgeschwader 7 ‘Nowotny’ and returned to the Luftwaffe after the war, ending his flying career on the F-104 Starfighter.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373db360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroesAll_Chapter104.vue
// module id = 87
// module chunks = 0